import React, { Component } from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import "../../../index.css";
import styles from '../../../style.js';
import {getParameterByGroupCode} from '../../Parameter/apiRequestService';
import {getAllMailAddress} from '../../CompanyContact/CompanyMail/apiRequestService';
import {getAllFtpAddress} from '../../CompanyContact/CompanyFtp/apiRequestService';
import * as Actions from '../../../redux/actions';
import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';
import _ from 'lodash';

class EndProcessAction extends Component {
 

  constructor(props) {
    super(props);
    this.gridFunc = React.createRef();
    this.state = {
      endProcessActionsList:[],
      registeredFtp:1,
      registeredFtpList:[],
      registeredEmail:1,
      registeredEmailList:[],
      newEmail:'',
      endProcessAction:{actionId:0,registeredFtp:null,registeredEmail:null,newEmail:''}
    };
  }


  componentDidMount() {
    this.setState({endProcessActionsList : this.props.endProcessActionsList});

    //Kayıtlı Ftp
    getAllFtpAddress()
    .then((response) => {
      const ftps= response.data;

      if (!_.isNil(ftps)) {
        let ftpList = [];
        for (let i = 0; i < ftps.length; i++) {
          ftpList.push({text:ftps[i].code,value:ftps[i].id});
        }
        this.setState({registeredFtpList:ftpList});
      }

    })
    .catch((exception) => {
      this.props.actions.setNotification("Firma ftp bilgileri getirilemedi daha sonra tekrar deneyin.", 'error');
      console.log('getAllFtpAddress exception: ' + JSON.stringify(exception));
    });  

    //Kayıtlı Email
    getAllMailAddress()
    .then((response) => {
      const mailAddresses= response.data;

      if (!_.isNil(mailAddresses)) {
        let mailAdressList = [];
        for (let i = 0; i < mailAddresses.length; i++) {
          mailAdressList.push({text:mailAddresses[i].emailAddress,value:mailAddresses[i].id});
        }
        this.setState({registeredEmailList:mailAdressList});
      }

    })
    .catch((exception) => {
      this.props.actions.setNotification("Firma mail adres bilgileri getirilemedi daha sonra tekrar deneyin.", 'error');
      console.log('getAllMailAddress exception: ' + JSON.stringify(exception));
    });  
  }

  handleChange = event => {
    const fieldName = event.target.name;
    const fieldValue = event.target.value;

    //this.setState({ [fieldName]: fieldValue });
    this.state.endProcessAction[fieldName]=fieldValue;

    this.props.handleEndProcessActionChange(this.state.endProcessAction);
  };
 
  render() {
    const { endProcessAction,endProcessActionsList,registeredFtpList,registeredEmailList } = this.state;

    let component = null;
    switch(endProcessAction.actionId) {
      case "1":
        component = 
          <div className='sameLine col-12 col-sm-4'>
          <InputLabel id="registeredFtpLabel" style={styles.label}>Gönderilecek Ftp</InputLabel>
          <Select
            fullWidth
            labelId="registeredFtpLabel"
            id="registeredFtpSelect"
            className='customSelect'
            value={endProcessAction.registeredFtp}
            name="registeredFtp"
            style={styles.selectField}
            onChange={this.handleChange}>
            {registeredFtpList.map((lItem) => (
              <MenuItem value={lItem.value}>
                <div style={styles.selectField}>{lItem.text}</div>
              </MenuItem>
            ))}
          </Select>
          </div>;
        break;
        case "2":
          component = 
            <div className='sameLine col-12 col-sm-4'>
            <InputLabel id="registeredEmailLabel" style={styles.label}>Gönderilecek E-Posta</InputLabel>
            <Select
              fullWidth
              labelId="registeredEmailLabel"
              id="registeredEmailSelect"
              className='customSelect'
              value={endProcessAction.registeredEmail}
              name="registeredEmail"
              style={styles.selectField}
              onChange={this.handleChange}>
              {registeredEmailList.map((lItem) => (
                <MenuItem value={lItem.value}>
                  <div style={styles.selectField}>{lItem.text}</div>
                </MenuItem>
              ))}
            </Select>
            </div>;
          break;
        case "3":
          component =
            <div className='sameLine col-12 col-sm-4'>
            <InputLabel id="newEmail-label" style={styles.label}>Gönderilecek E-Posta Adresi</InputLabel>
            <TextField className="customInputText" sx = {styles.textField} labelId="newEmail-label" id="newEmailText" name="newEmail" value={endProcessAction.newEmail} variant="outlined" onChange={this.handleChange} placeholder="Gönderilecek E-Posta Adresi"/>
            </div>;
          break;
      default:
        component = null;
    }

    return (
      <div>
      <Box sx={{ width: '100%' }}>
      <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>

        <Grid item xs={12}>
          <Box sx={styles.boxClass}>
            <div className="headerStyle"><h4>Süreç Sonu Eylemi</h4></div>
            <div className='component row'>
              <div className='sameLine col-12 col-sm-4'>
              <InputLabel id="endProcessActionLabel" style={styles.label}>Süreç Tamamlandığında</InputLabel>
              <Select
              className='customSelect'
                fullWidth
                labelId="endProcessActionLabel"
                id="endProcessActionLabelSelect"
                value={endProcessAction.actionId}
                name="actionId"
                style={styles.selectField}
                onChange={this.handleChange}>
                {endProcessActionsList.map((nType) => (
                  <MenuItem value={nType.parameterValue}>
                    <div style={styles.selectField}>{nType.parameterName}</div>
                  </MenuItem>
                ))}
              </Select>
              </div>
              {component}
            </div>
          </Box>
        </Grid>

      </Grid>
    </Box>
      </div>
    );
  }
}

// export default (EndProcessAction);
const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(Actions, dispatch)
});

export default compose(
  connect(
    null,
    mapDispatchToProps
  ),
)(EndProcessAction);